import { useEffect } from "react";
import {
  DEFAULT_SHARE_IMAGE,
  SITE_NAME,
  clampDescription,
  toAbsoluteImageUrl,
  toAbsoluteUrl,
} from "./seo";

function ensureMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      element.setAttribute(key, value);
    }
  });
}

function ensureLink(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      element.setAttribute(key, value);
    }
  });
}

export default function SeoManager({
  title,
  description,
  path = "/",
  image,
  type = "website",
  robots = "index,follow",
  keywords = "",
  schema = null,
}) {
  useEffect(() => {
    const resolvedTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const resolvedDescription = clampDescription(
      description,
      "Shop authentic gold jewelry online with Asher Jewels PH. Explore bracelets, rings, necklaces, earrings, and more with secure checkout and delivery."
    );
    const canonical = toAbsoluteUrl(path);
    const shareImage = toAbsoluteImageUrl(image || DEFAULT_SHARE_IMAGE);

    document.title = resolvedTitle;

    ensureMeta('meta[name="description"]', { name: "description", content: resolvedDescription });
    ensureMeta('meta[name="robots"]', { name: "robots", content: robots });
    ensureMeta('meta[name="keywords"]', { name: "keywords", content: keywords });

    ensureMeta('meta[property="og:type"]', { property: "og:type", content: type });
    ensureMeta('meta[property="og:site_name"]', { property: "og:site_name", content: SITE_NAME });
    ensureMeta('meta[property="og:title"]', { property: "og:title", content: resolvedTitle });
    ensureMeta('meta[property="og:description"]', { property: "og:description", content: resolvedDescription });
    ensureMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    ensureMeta('meta[property="og:image"]', { property: "og:image", content: shareImage });

    ensureMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    ensureMeta('meta[name="twitter:title"]', { name: "twitter:title", content: resolvedTitle });
    ensureMeta('meta[name="twitter:description"]', { name: "twitter:description", content: resolvedDescription });
    ensureMeta('meta[name="twitter:image"]', { name: "twitter:image", content: shareImage });

    ensureLink('link[rel="canonical"]', { rel: "canonical", href: canonical });

    const scriptId = "asher-seo-structured-data";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }

    script.textContent = schema ? JSON.stringify(Array.isArray(schema) ? schema : [schema]) : "";
  }, [title, description, path, image, type, robots, keywords, schema]);

  return null;
}
